import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IDealerContractPopup } from '../commonModels/dealerContractModels'

export class ContractPopUp extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'homepage/IsContractPopup',
      requesterInfo,
    })
  }

  /**
   * Sözleşme/belge onayı tamamlanmamış bayi için modal durumunu döner.
   * Popup gerekmiyorsa (kural dışı bayi veya akış tamamlanmış) null döner.
   */
  public async contractPopup(): Promise<IDealerContractPopup | null> {
    return await this.getAsync<IDealerContractPopup | null>()
  }
}
